// HomeContent.js

import { Text, Box, Grommet, ResponsiveContext } from "grommet";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { UserContext } from "../../App";

const HomeContent = () => {
    const navigate = useNavigate();
    
    const theme = {
        global: {
            font: { family: "Segoe UI", size: "14px" },
        },
    };

    const currentUser = useContext(UserContext);

    return (
        
        <ResponsiveContext.Consumer>
            {screenSize => (
                <Grommet theme={theme}>
                    <Box
                        style={{ 
                            position: 'absolute',
                            height: '80%',
                            width: '90%',
                            }}>

                        <Box
                            flex
                            fill="vertical"
                            width="90%"
                            margin="auto"
                            pad="medium"
                            //border={{ color: "red", size: "medium" }} // Debugging border
                        >
                            <Box
                                flex
                                direction={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "column" : "row"}
                                align="stretch"
                                gap="medium"
                                fill="horizontal"
                            >
                                {/* Evaluation Sheet */}
                                <Box
                                    flex
                                    direction="column"
                                    justify="center"
                                    border={{ color: "#01548C", size: "small" }}
                                    margin={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "5% 0" : "0px"}
                                    align="center"
                                    round="xsmall"
                                    width={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "100%" : "48%"}
                                    height={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "50%" : "100%"}
                                    gap="small"
                                    background={{
                                    size: "contain",
                                    repeat: "no-repeat",
                                    color: "white",
                                    image: "url('EvaluationSheet.JPG')",
                                    }}
                                    hoverIndicator={{ elevation: "xlarge" }}
                                    onClick={() => {
                                    if (currentUser) {
                                        navigate("/eval-sheet", { state: { editMode: false } });
                                    } else {
                                         navigate("/login");
                                    }
                                    }}
                                >
                                    {/* <Box align="center" justify="center" pad="medium" border={{ color: "blue", size: "medium" }}>
                                    Evaluation Sheet
                                    </Box> */}
                                </Box>

                                {/* Both: Queries and Evaluation Management */}
                                <Box
                                    flex={true}
                                    direction="column"
                                    justify="between"
                                    width={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "100%" : "48%"}
                                    height={screenSize === "xsmall" || screenSize === "small" || screenSize === "medium" ? "50%" : "100%"}
                                    gap="small"
                                >
                                    {/* Queries */}
                                    <Box
                                      //  flex={{ grow: 1 }}
                                        direction="column"
                                        border={{ color: "#01548C", size: "small" }}
                                        height="30%"
                                        align="center"
                                        round="xsmall"
                                        background={{
                                            size: "contain",
                                            repeat: "no-repeat",
                                            color: "white",
                                            image: "url('Queries.JPG')",
                                        }}
                                        hoverIndicator={{ elevation: "xlarge" }}
                                        onClick={() => {
                                            if (currentUser) {
                                                navigate("/queries");
                                            } else {;
                                                navigate("/login");
                                            }
                                        }}
                                    >
                                        {/* <Box align="center" justify="center" pad="medium" border={{ color: "green", size: "medium" }}>
                                            Queries
                                        </Box> */}
                                    </Box>

                                    {/* Evaluation Management */}
                                    <Box
                                      //  flex={{ grow: 2 }}
                                        direction="column"
                                        border={{ color: "#01548C", size: "small" }}
                                        height="60%"
                                        align="center"
                                        round="xsmall"
                                        background={{
                                            size: "contain",
                                            repeat: "no-repeat",
                                            color: "white",
                                            image: "url('EvaluationManagement.JPG')",
                                        }}
                                        hoverIndicator={{ elevation: "xlarge" }}
                                        
                                        onClick={() => {
                                            if (currentUser) {
                                                navigate("/eval-manager");
                                            } else {
                                                navigate("/login");
                                            }                                      
                                        }}>
                                        {/* <Box align="center" justify="center" pad="medium" border={{ color: "orange", size: "medium" }}>
                                            Evaluation Management
                                        </Box> */}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
            </Grommet>
            )}
        </ResponsiveContext.Consumer>
    );
};

export default HomeContent;
